type KeysMatching<T extends object, V> = {
  [K in keyof T]-?: T[K] extends V ? K extends string ? K : never : never
}[keyof T]

type FetchApiKeys<T extends object> = KeysMatching<T, FetchBase>

type FetchBase = (...args: [tenant: string, ...params: any, initOverrides?: RequestInit]) => Promise<any>

type FetchApi<T extends object> = { [key in FetchApiKeys<T>]: T[key] extends FetchBase ? T[key] : never }

type HeadTail<T extends any[]> = RemoveOpt<T> extends [any, ...infer Head, any] ? Head : never

type AddUndefined<T, OriginalT> = (
    {
      [index in keyof T]: (
        undefined extends OriginalT[Extract<index, keyof OriginalT>]
          ? undefined | T[index]
          : T[index]
      )
    }
)
type RemoveOpt<T> = (
    AddUndefined<
      {
        [index in keyof T]-?: T[index]
      },
      T
    >
)

export function tenantProxy<
  T extends object,
  API extends FetchApi<T>,
>(
  api: T,
  tenant: () => string,
): { [key in keyof API]: (...params: HeadTail<Parameters<API[key]>>) => ReturnType<API[key]> } {
  const handler = {
    get(_: any, method: keyof API) {
      return async (...params: any[]) => {
        return await ((api as any as API)[method] as FetchBase)(tenant(), ...params)
      }
    },
  }
  return new Proxy({} as any, handler as any)
}
